import { Language } from '@/models/language';

export class StringUtils {
  public static readonly usableLanguages: Language[] = [
    //{ langCode: 'ja', langName: '日本語', dispName: '日本語' },
    //{ langCode: 'en', langName: 'English', dispName: 'English' },
    // { langCode: 'vi', langName: 'Tiếng Việt' },
    // { langCode: 'id', langName: 'Bahasa indonesia' },
  ];

  public static browserLanguage(): string {
    // 強制日本語
    // TODO 英語対応時に変更する
    return 'ja';
    // let lang = window.navigator.language;
    // if (lang) {
    //   if (lang.indexOf('en') >= 0) {
    //     return 'en';
    //   } else if (lang.indexOf('ja') >= 0) {
    //     return 'ja';
    //   } else {
    //     return 'en';
    //   }
    // } else {
    //   return 'en';
    // }
  }

  public static getLanguageByCode(langCode?: string): Language | undefined {
    langCode = langCode || StringUtils.browserLanguage();
    const index = StringUtils.usableLanguages.findIndex(v => v.langCode === langCode);
    if (index >= -1) {
      return StringUtils.usableLanguages[index];
    }
  }

  public static isBlank(str: string): boolean {
    return !str || str.trim().length === 0;
  }
  /**
   * Mailアドレスチェック
   * @param emailAddress メールアドレス文字列
   */
  public static isValidEmail(emailAddress: string): boolean {
    const EMAIL_REGEX: RegExp = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    return EMAIL_REGEX.test(emailAddress);
  }

  /**
   * パスワードチェック（大文字、小文字、数値含めて桁以上）
   * @param value
   */
  public static isValidPassword(value: string): boolean {
    return /[A-Z]+/.test(value) && /[a-z]+/.test(value) && /[\d]+/.test(value) && value.length >= 8;
  }

  /**
   * URLのフルパスからベースURL部分を取得
   * @param fullPath
   */
  public static getBaseUrlFromFullPath(fullPath: string): string {
    let index = fullPath.indexOf('?');
    if (index !== -1) {
      return fullPath.slice(0, index);
    } else {
      return '';
    }
  }

  /**
   * 簡易版レポートの正しいURLか判定
   * @param baseUrl URL String Object
   */
  public static isValidSimpleZipUrl(baseUrl: string): boolean {
    // %E5%BC%B7%E3%81%BF%E7%99%BA%E8%A6%8B%E7%89%88 は、「強み発見版」のエンコード後文字列
    const SIMPLE_ZIP_URL_REGEX: RegExp = /^https:\/\/(.*)\/report_zip\/[0-9]+\/[0-9]+_%E5%BC%B7%E3%81%BF%E7%99%BA%E8%A6%8B%E7%89%88\.zip$/;
    return SIMPLE_ZIP_URL_REGEX.test(baseUrl);
  }
}
